import type { TraceabilityData } from './types';

export const LABELS: Record<keyof TraceabilityData, string> = {
  expiryDate: 'Expiry Date',
  manufactureDate: 'Manufacture Date',
  resinName: 'Resin Trade Name',
  lotNumber: 'Resin Lot / Batch Number',
  patientCode: 'Patient Name / Code',
  orderNumber: 'Prescription / Order Number',
  orderDescription: 'Prescription / Order Description',
  clinicName: 'Dental Lab / Clinic Name',
  address: 'Address of Lab / Clinic',
  ownerName: 'Owner Name',
};

export const DECLARATION =
  'This custom-made dental device was manufactured using the above-identified resin in accordance with the requirements for custom-made devices set out in Annexes I & XIII of Regulation (EU) 2017/745.';
